import { render, staticRenderFns } from "./SectionRiskCodesEdit.vue?vue&type=template&id=ecc95a2a&scoped=true&"
import script from "./SectionRiskCodesEdit.vue?vue&type=script&lang=js&"
export * from "./SectionRiskCodesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecc95a2a",
  null
  
)

export default component.exports